import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFieldMobileVi = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={371}
        height={620}
        fill="none"
        viewBox="0 0 371 620"
        {...props}
    >
        <path fill="#5ABA3A" d="M0 0h370.032v62H0z" />
        <path fill="#55B137" d="M0 62h370.032v62H0z" />
        <path fill="#5ABA3A" d="M0 124h370.032v62H0z" />
        <path fill="#55B137" d="M0 186h370.032v62H0z" />
        <path fill="#5ABA3A" d="M0 248h370.032v62H0z" />
        <path fill="#55B137" d="M0 310h370.032v62H0z" />
        <path fill="#5ABA3A" d="M0 372h370.032v62H0z" />
        <path fill="#55B137" d="M0 434h370.032v62H0z" />
        <path fill="#5ABA3A" d="M0 496h370.032v62H0z" />
        <path fill="#55B137" d="M0 558h370.032v62H0z" />
        <path
            stroke="#fff"
            strokeWidth={4}
            d="M0 310h370.032M186.027 264c25.652 0 46.486 20.574 46.486 46s-20.834 46-46.486 46-46.484-20.574-46.484-46 20.832-46 46.484-46Z"
        />
        <path stroke="#fff" strokeWidth={4} d="M2 2h366.032v616H2z" />
        <mask
            id="a"
            width={16}
            height={14}
            x={355}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M370.032 0v14h-14.154V0z" />
        </mask>
        <g mask="url(#a)">
            <path
                stroke="#fff"
                strokeWidth={4}
                d="M374.098 4c0 4.398-3.611 8-8.111 8-4.499 0-8.11-3.602-8.11-8s3.611-8 8.11-8c4.5 0 8.111 3.602 8.111 8Z"
            />
        </g>
        <mask
            id="b"
            width={16}
            height={14}
            x={355}
            y={606}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M370.032 620h-14.154v-14h14.154z" />
        </mask>
        <g mask="url(#b)">
            <path
                stroke="#fff"
                strokeWidth={4}
                d="M365.987 624c-4.499 0-8.11-3.602-8.11-8s3.611-8 8.11-8c4.5 0 8.111 3.602 8.111 8s-3.611 8-8.111 8Z"
            />
        </g>
        <mask
            id="c"
            width={15}
            height={14}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M0 0h14.154v14H0z" />
        </mask>
        <g mask="url(#c)">
            <path
                stroke="#fff"
                strokeWidth={4}
                d="M4.045-4c4.5 0 8.11 3.602 8.11 8s-3.61 8-8.11 8-8.11-3.602-8.11-8 3.61-8 8.11-8Z"
            />
        </g>
        <mask
            id="d"
            width={15}
            height={14}
            x={0}
            y={606}
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
        >
            <path fill="#fff" d="M0 620v-14h14.154v14z" />
        </mask>
        <g mask="url(#d)">
            <path
                stroke="#fff"
                strokeWidth={4}
                d="M-4.065 616c0-4.398 3.61-8 8.11-8s8.11 3.602 8.11 8-3.61 8-8.11 8-8.11-3.602-8.11-8Z"
            />
        </g>
        <path
            stroke="#fff"
            strokeWidth={4}
            d="M147.399 85.5c7.102 13.376 21.283 22.5 37.619 22.5s30.516-9.124 37.618-22.5"
        />
        <path stroke="#fff" strokeWidth={4} d="M79.848 2h210.336v84H79.848z" />
        <path
            stroke="#fff"
            strokeWidth={4}
            d="M138.488 2h93.058v28h-93.058zM147.138 535c7.011-13.649 21.341-23 37.879-23 15.925 0 29.803 8.671 37.07 21.5"
        />
        <path stroke="#fff" strokeWidth={4} d="M79.848 534h210.336v84H79.848z" />
        <path stroke="#fff" strokeWidth={4} d="M138.488 590h93.058v28h-93.058z" />
        <ellipse cx={185.066} cy={310} fill="#fff" rx={6.066} ry={6} />
    </svg>
);
export default SvgFieldMobileVi;
